export default __webpack_public_path__ + "static/media/duration.0d4adac4.svg";